import styled from "styled-components"
import { motion } from "framer-motion"
import { IconButton } from "@material-ui/core"
import Light1Icon from "./light_placeholder.jpg"
import Dark1Icon from "./dark_placeholder.jpg"

export const Title = styled.p`
  font-family: Lora-Regular;
  font-size: 5.5vw;
  color: ${({ color }) => color};
  padding: 0;
  margin: 0;
  margin-bottom: 2vw;
`

export const Label = styled.p`
  font-family: AzoSans-Regular;
  font-size: 0.8vw;
  color: ${({ color }) => color};
  padding: 0;
  margin: 0;
  margin-bottom: 3vw;
  width: 45%;
  line-height: 130%;
  min-width: 350px;
`

export const Title1 = styled.p`
  font-family: Lora-Regular;
  font-size: 5.5vw;
  color: ${({ color }) => color};
  padding: 0;
  margin: 0;
`

export const Label1 = styled.p`
  font-family: AzoSans-Regular;
  font-size: 0.8vw;
  color: ${({ color }) => color};
  padding: 0;
  margin: 0;
  margin-bottom: 1.5vw;
  width: 45%;
  line-height: 130%;
  min-width: 350px;
  text-align: right;
`

export const Holder = styled(motion.div)`
  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100vw;
  display: inline-flex;
`
export const LightHolder = styled.div`
  width: 50%;
  height: 100%;
  padding: 0 4vw 6vw 0;
  position: relative;
`

export const LightBgHolder = styled.div`
  width: 100%;
  height: 100%;
  background-color: #9db7ad;
  padding: 4vw 2vw;
`
export const LightPH = styled.div`
  position: absolute;
  bottom: 10vw;
  left: 38%;
  z-index: 1;
  width: 24vw;
  height: 29vw;
  background-image: url(${Light1Icon});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  filter: drop-shadow(0px 5px 4px rgba(0, 0, 0, 0.25));
  cursor: pointer;
  transition: transform 800ms cubic-bezier(0.075, 0.82, 0.165, 1);
  &:hover {
    transform: translateX(-20px);
  }
`

export const DarkHolder = styled.div`
  width: 50%;
  height: 100%;
  padding: 6vw 0 0 4vw;
  position: relative;
`

export const DarkBgHolder = styled.div`
  width: 100%;
  height: 100%;
  background-color: #667977;
  padding: 4vw 2vw;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
`

export const DarkPH = styled.div`
  position: absolute;
  top: 10vw;
  right: 38%;
  z-index: 1;
  width: 24vw;
  height: 29vw;
  background-image: url(${Dark1Icon});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  filter: drop-shadow(0px 5px 4px rgba(0, 0, 0, 0.25));
  cursor: pointer;
  transition: transform 800ms cubic-bezier(0.075, 0.82, 0.165, 1);
  &:hover {
    transform: translateX(10px);
  }
`

export const BackButton = styled(IconButton)`
  position: absolute !important;
  z-index: 1;
  left: 1rem;
  bottom: 1rem;
  width: 3em;
`
export const BackIcon = styled.img`
  width: 100%;
`

export const DialogContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  background-color: #232323;
  display: inline-flex;
  user-select: none;
`
